<template><div><h1>VUX V2.0.14 发布日志</h1>
<h2><a href="/zh-CN/components/grid.html">Grid</a></h2>
<ul><li>[feature] 增加`grid`九宫格组件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.14 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.14-197.vue?59edb424